/**
 * Created by Andrey Popov on 12/1/20.
 */

const Chat = function () {
    this.messages = [];

    cleverapps.EventEmitter.call(this);

    this.editingMode = false;
    this.closing = false;
    this.hasUnread = false;
    this.wasUnreadMessages = false;
    this.activeDialogueId = undefined;

    this.baseApiUrl = `${cleverapps.config.crmApiURL}/chat`;

    this.loadSave();

    cleverapps.timeouts.setInterval(this.checkReload.bind(this), Chat.CHECK_RELOAD_INTERVAL);

    connector.platform.on("userIdChanged", () => {
        this.load();
    });
};

Chat.prototype = Object.create(cleverapps.EventEmitter.prototype);
Chat.prototype.constructor = Chat;

Chat.IsAvailable = function () {
    if (cleverapps.chat.hasUnread) {
        return true;
    }

    if (cleverapps.flags.norest || connector.platform.oneOf(
        connector.MOBAGE,
        connector.SP_MOBAGE,
        connector.GDCOM,
        connector.COOLMATHGAMES,
        connector.G5WINDOWS,
        connector.ARKADIUM
    )) {
        return false;
    }

    return true;
};

Chat.prototype.loadSave = function () {
    const info = cleverapps.dataLoader.load(DataLoader.TYPES.CHAT) || {};

    this.processed = info.processed || {};
};

Chat.prototype.storeSave = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.CHAT, {
        processed: this.processed
    });
};

Chat.prototype.init = function () {
    this.load();
};

Chat.prototype.load = function (callback, errorCallback) {
    this.lastLoad = Date.now();

    if (cleverapps.isLocalhost()) {
        if (callback) {
            callback();
        }
        return;
    }

    cleverapps.RestClient.get(
        `${this.baseApiUrl}/messages/${encodeURIComponent(connector.platform.getUserID())}`,
        {},
        (messages) => {
            this.processMessages(Array.isArray(messages) ? messages : []);

            MenuControlButton.updateAttention();

            if (callback) {
                callback();
            }
        },

        (error) => {
            MenuControlButton.updateAttention();
            
            if (errorCallback) {
                errorCallback(error);
            } else {
                this.printConnectionError(error);
            }
        }
    );
};

Chat.prototype.processMessages = function (messages) {
    const serverMessages = messages.map(ChatMessage.fromData);

    this.messages = [];
    this.hasUnread = false;

    let dateStr = undefined;
    let changeConsoleStreamMode = undefined;
    let dialogueId = undefined;

    serverMessages.forEach((message) => {
        if (dialogueId && message.dialogueId !== dialogueId) {
            this.messages.push(ChatMessage.createSeparator(dialogueId));
        }
        dialogueId = message.dialogueId;

        let messageDate;
        try {
            messageDate = new Date(message.postDate).toLocaleDateString(cleverapps.settings.language || "en-US", { year: "numeric", month: "long", day: "numeric" });
        } catch (e) {
            messageDate = new Date(message.postDate).toDateString();
        }

        if (messageDate !== dateStr) {
            dateStr = messageDate;
            this.messages.push(ChatMessage.createServiceMessage(messageDate));
        }

        if (message.isResponse === 1 && message.readByUser === 0 || message.hasGift() && !message.isGiftTaken() && message.isApplicable()) {
            this.hasUnread = true;
            this.wasUnreadMessages = true;
        }

        if (message.hasGift() && this.processed[message.id]) {
            if (message.isGiftTaken()) {
                delete this.processed[message.id];
                this.storeSave();
            } else {
                cleverapps.RestClient.post(`${this.baseApiUrl}/acceptGift`, { id: message.id });
            }
        }

        if (message.isTurningOnConsoleStream()) {
            changeConsoleStreamMode = true;
            this.messages.push(ChatMessage.createServiceMessage({ localize: "ChatConsoleStreamSwitchOn" }, message.id));
        } else if (message.isTurningOffConsoleStream()) {
            changeConsoleStreamMode = false;
            this.messages.push(ChatMessage.createServiceMessage({ localize: "ChatConsoleStreamSwitchOff" }, message.id));
        } else {
            this.messages.push(message);
        }
    });

    if (changeConsoleStreamMode !== undefined && changeConsoleStreamMode) {
        cleverapps.consoleStream.enable(this.postMessage.bind(this, "Disable console stream", "stream_off", true));
    } else if (changeConsoleStreamMode !== undefined && !changeConsoleStreamMode) {
        cleverapps.consoleStream.disable();
    }

    if (this.messages.length === 0) {
        this.messages.push(ChatMessage.createServiceMessage({ localize: "ChatGreetingMessage" }));
    } else if (this.getLastMessage() && ["resolved", "no answer needed"].indexOf(this.getLastMessage().status) !== -1) {
        this.messages.push(ChatMessage.createSeparator(dialogueId));
    } else {
        this.activeDialogueId = dialogueId;
    }

    if (!this.closing) {
        this.trigger("removeMessagesByType", ChatMessage.MESSAGE_TYPE.TEMPORARY);
        this.trigger("messagesUpdated");
    }
};

Chat.prototype.postMessage = function (message, categoryTag, silent) {
    const tmpMessage = ChatMessage.createTemporaryMessage(message);
    this.messages.push(tmpMessage);
    if (!silent) {
        this.trigger("messagesUpdated");
    }

    let playerName = cleverapps.user.getPlayerInfo().name;
    if (playerName === Messages.get("Friends.You")) {
        playerName = Messages.get("LeaguesWindow.player");
    }

    let payerLevel = cleverapps.paymentsHistory.classify();
    if (payerLevel <= cleverapps.PaymentsHistory.BRACKET_NONE && cleverapps.paymentsHistory.isPayer()) {
        payerLevel = cleverapps.PaymentsHistory.BRACKET_WEAK;
    }

    let level = cleverapps.user.getHumanReadableNumber();
    if (cleverapps.user.isPlayingFakeLevels()) {
        const chosen = cleverapps.user.getRandomLevel();
        level = cleverapps.humanReadableNumber(chosen.episodeNo, chosen.levelNo);
    }

    cleverapps.RestClient.post(
        `${this.baseApiUrl}/message`,
        {
            message,
            userid: connector.platform.getUserID(),
            isresponse: 0,
            payerlevel: payerLevel,
            name: playerName,
            language: cleverapps.settings.language,
            source: connector.info.source,
            categoryTag,
            level,
            version: cleverapps.config.version
        },
        () => {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CRM.POST);

            this.load();

            SnapshotAdapters.extractData((snapshotData) => {
                Meta.SLOTS.forEach((slotId) => {
                    delete snapshotData[`units${slotId}`];
                    delete snapshotData[`unitslibrary${slotId}`];
                    delete snapshotData[`quests${slotId}`];
                });
                cleverapps.RestClient.post(`${this.baseApiUrl}/snapshot/${
                    encodeURIComponent(connector.platform.getUserID())}`, snapshotData);
            });
        },
        () => {
            const index = this.messages.indexOf(tmpMessage);
            if (index !== -1) {
                this.messages.splice(index, 1);
            }

            if (!silent) {
                this.trigger("removeMessagesByType", ChatMessage.MESSAGE_TYPE.TEMPORARY);
                this.trigger("returnMessageBack", message);
                this.printConnectionError();
            }

            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CRM.POST_FAILED);
        }
    );
};

Chat.prototype.getLastMessage = function (fromUserOnly) {
    const chatMessages = cleverapps.chat.messages.filter((dialogueMessage) => dialogueMessage.dialogueId && dialogueMessage.status && (!fromUserOnly || dialogueMessage.isResponse !== 1));

    if (chatMessages.length > 0) {
        return chatMessages[chatMessages.length - 1];
    } 
    return undefined;
};

Chat.prototype.markAsRead = function () {
    const unread = this.messages.filter((message) => message.isResponse === 1 && message.readByUser === 0);
    const gifts = unread.filter((message) => message.hasGift()).length;
    const answers = unread.length - gifts;

    if (answers > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CRM.REPLY_VIEWED, { itemId: "answer", counter: answers });
    }
    if (gifts > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CRM.REPLY_VIEWED, { itemId: "gift", counter: gifts });
    }

    cleverapps.RestClient.post(`${this.baseApiUrl}/markAsRead`, { userid: connector.platform.getUserID() });
};

Chat.prototype.acceptGift = function (message, take) {
    if (this.processed[message.id]) {
        this.load();
        return;
    }

    let useRewardWindow = false;

    if (take) {
        if (message.progress) {
            cleverapps.user.currentPhysicalLevel.level = parseInt(message.progress.level);
            cleverapps.user.currentPhysicalLevel.episode = parseInt(message.progress.episode);
            cleverapps.user.currentPhysicalLevel.progress = 0;
            cleverapps.user.save();

            if (["crocword", "riddles"].includes(cleverapps.config.name)) {
                const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
                slot.save("stage", cleverapps.user.currentPhysicalLevel.episode);
                slot.save("progress", cleverapps.user.currentPhysicalLevel.level);
                cleverapps.meta.resetProgress();
            } else if (["olympics"].includes(cleverapps.config.name)) {
                const total = levels.user.currentPhysicalLevel.episode * Level.LEVELS_PER_EPISODE + levels.user.currentPhysicalLevel.level + levels.user.currentPhysicalLevel.progress;
                const stage = Math.floor(total / ShortMetaLocation.LEVELS_PER_LOCATION) || 0;
                const progress = (total % ShortMetaLocation.LEVELS_PER_LOCATION) || 0;

                const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
                slot.save("stage", stage);
                slot.save("progress", progress);
                cleverapps.meta.resetProgress();
            }

            if (cleverapps.playButton) {
                cleverapps.playButton.reset();
            }
        } else if (message.restoreProgressId) {
            cleverapps.importProgress(message.restoreProgressId, {
                callback: (code) => {
                    if (code === "load_failed") {
                        cleverapps.notification.create("Error load progress");
                    }
                }
            });
        } else if (message.harvested || message.presents) {
            useRewardWindow = true;

            let expedition, reward;

            if (message.harvested) {
                expedition = "main";
                reward = { harvested: message.harvested };
            } else {
                expedition = message.presents.expedition;
                reward = cleverapps.clone(message.presents, true);
                delete reward.expedition;
            }

            cleverapps.chatPresents = {
                reward,
                callback: function () {
                    cleverapps.chat.processed[message.id] = true;
                    cleverapps.chat.storeSave();
                    cleverapps.RestClient.post(`${this.baseApiUrl}/acceptGift`, { id: message.id }, () => {
                        cleverapps.chat.load();
                    });
                }.bind(this)
            };
            this.closing = true;

            if (cleverapps.meta.listActiveLocations().indexOf(expedition) !== -1) {
                cleverapps.focusManager.display({
                    focus: "closeScene",
                    action: function (f) {
                        cleverapps.meta.switchLocation(expedition);
                        cleverapps.meta.gotoLocationScene(f);
                    }
                });
            } else {
                cleverapps.Scenes.GetRunningScene().sceneComponent.closeAction();
            }
        } else if (message.metha) {
            // todo
        }

        cleverapps.effects.fire("ui.shop.buy");
    }

    if (!useRewardWindow) {
        this.processed[message.id] = true;
        this.storeSave();
        cleverapps.RestClient.post(`${this.baseApiUrl}/acceptGift`, { id: message.id }, () => {
            cleverapps.chat.load();
        });
    }
};

Chat.prototype.printConnectionError = function () {
    this.messages.push(ChatMessage.createServiceMessage({ localize: "RestartWindow.CheckInternetConnection" }, `error_${Date.now()}`));
    this.trigger("messagesUpdated");
};

Chat.prototype.checkReload = function () {
    if (!Chat.IsAvailable()) {
        return;
    }

    if (!cleverapps.environment.hasScene([cleverapps.Environment.SCENE_MAIN, cleverapps.Environment.SCENE_CHAT])) {
        return;
    }

    const reloadInterval = cleverapps.environment.isChatScene() ? Chat.CHAT_RELOAD_INTERVAL : Chat.RELOAD_INTERVAL;
    if (this.lastLoad + reloadInterval > Date.now()) {
        return;
    }

    this.load();
};

Chat.prototype.giveRewards = function () {
    const unit = cleverapps.config.type === "merge" && cleverapps.chatPresents.reward.unit;
    if (unit) {
        const left = unit.amount - Map2d.currentMap.countEmptySlots();
        if (left > 0) {
            delete cleverapps.chatPresents;
            cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left }));
            return;
        }

        if (!this.canAcceptUnit(unit)) {
            delete cleverapps.chatPresents;
            cleverapps.centerHint.createTextHint(Messages.get("RestartWindow.OnError"));
            return;
        }

        if (unit.code === "landmark") {
            const data = Landmarks.getLandmarkData(unit.stage);
            if (data) {
                unit.targetExpedition = data.targetExpedition;
            }
        }
    }

    cleverapps.focusManager.display({
        focus: "chatPresentsWindow",
        actions: [
            function (f) {
                if (cleverapps.chatPresents.reward.stickers) {
                    const stickers = cleverapps.chatPresents.reward.stickers;
                    delete cleverapps.chatPresents.reward.stickers;

                    const rewards = new RewardsList({ stickers }, { event: cleverapps.EVENTS.EARN.CHAT_PRESENT });
                    rewards.receiveRewards();

                    if (cleverapps.stickersBook && cleverapps.stickersBook.newStickers) {
                        new StickersRewardWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                        return;
                    }
                }

                f();
            },
            function (f) {
                if (Object.keys(cleverapps.chatPresents.reward).length !== 0) {
                    new RewardWindow(cleverapps.chatPresents.reward, { event: cleverapps.EVENTS.EARN.CHAT_PRESENT });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                } else {
                    f();
                }

                cleverapps.chatPresents.callback();
                delete cleverapps.chatPresents;
            }
        ]
    });
};

Chat.prototype.canAcceptUnit = function (unit) {
    if (!cleverapps.meta.getSelectedLocation().locationConfig.isMain && !Families[unit.code].expeditions.includes("main")) {
        return true;
    }
    return ["landmark"].includes(unit.code) || cleverapps.unitsLibrary.isOpened(unit) || Families[unit.code].units[unit.stage].climbable;
};

Chat.CHECK_RELOAD_INTERVAL = cleverapps.parseInterval("30 seconds");
Chat.CHAT_RELOAD_INTERVAL = cleverapps.parseInterval("1 minute");
Chat.RELOAD_INTERVAL = cleverapps.parseInterval("15 minutes");

Chat.LATE_REPLY_INTERVAL = cleverapps.parseInterval("5 days");
